import { Component } from '@angular/core';

@Component({
  selector: 'app-stacked-bar-chart-custom',
  template: `<app-chart-output></app-chart-output>`,
  styles: [
  ]
})
export class StackedBarChartComponentCustom {

}
